import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Title, SegmentedControl, Container, Group, Box, Button } from '@mantine/core';
import { IconArrowLeft} from '@tabler/icons-react';
import { loadProcesses } from '../actions/processActions';

import DashboardResume from '../components/Admin/DashboardView';
import DashboardProcess from '../components/Admin/ProcessView';
import PlanesEstrategicos from '../components/Admin/PeiView';

const AdminPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const {allProcess, loading} = useSelector((state) => state.process);

  const [activeTab, setActiveTab] = useState('process');
  
  useEffect (()=>{
    handleFetchData();
  },[])

  const handleFetchData = () => {
    dispatch(loadProcesses(null,null,user));
  };

  const renderTab = () => {
    switch (activeTab) {
      case 'dashboard':
        return (
          <DashboardResume/>
        );
      case 'process':
        return (
          <DashboardProcess 
            processes={allProcess} 
            loading={loading}
          />
        );
      case 'pei':
        return (
          <PlanesEstrategicos />
        );
      default:
        return null;
    }
  };

  return (
    <Container size="80%" py="xl">
      <section className='bienvenida'>
        <div className='bienvenida-header'>
          <Group justify={'space-between'}>
            <Box >
              <Title fw={400} order={1} >Panel de Administración</Title>
            </Box>
            <Group>
              <Button 
                variant='default' 
                leftSection={<IconArrowLeft size={18}/>} 
                onClick={() => navigate(-1)}
              >
                Volver
              </Button>
            </Group>
          </Group>
        </div>
      </section>
      <Box>
        <SegmentedControl
          fullWidth
          //color="#c70050"
          withItemsBorders={false}
          value={activeTab}
          onChange={setActiveTab}
          data={[
            { label: 'Resumen', value: 'dashboard', disabled:true },
            { label: 'Procesos Evaluativos', value: 'process' },
            { label: 'Planes Estratégicos', value: 'pei'},
          ]}
        />
      </Box>
      <section style={{ marginTop: 24 }}>{renderTab()}</section>
    </Container>
  );
};

export default AdminPage;
